module.exports = __webpack_public_path__ + "media/images/facebook-icon-bd073908a9f418bfc4b83e60c3177951.svg";